export default __webpack_public_path__ + "static/media/checkmark2.23061403.png";